<template>
  <div class="social">
        <b-container fluid >
            <div class="row">           
                <b-col cols="12" md="4" class="mycontainer-main m-borders">
                    <div class="row h-100 pl-5">
                        <div class="col-sm-12 align-self-center text-left">
                            <div>
                                <h1 class="fade-in" >{{ $t('social.jumbo-title') }}</h1>
                                <p class="fade-in" >{{ $t('social.jumbo-message') }}</p>
                                <br>
                                <div>
                                    <p><i class="fa fa-facebook-official fa-2x mx-1" >
                                       <a href="https://www.facebook.com/beauteintegrale"> /beauteintegrale</a>
                                        </i> 
                                    </p>                                    
                                </div>
                                <div>
                                    <p><i class="fa fa-instagram fa-2x mx-1" >
                                        <a href="https://www.instagram.com/beauteintegrale/"> #beauteintegrale</a>
                                        </i> 
                                    </p>    
                                </div> 
                                <!-- <div>
                                    <p><i class="fa fa-twitter fa-2x mx-1" >                                        
                                        <a href="https://www.instagram.com/beauteintegrale/"> @beauteintegrale</a>
                                        </i> 
                                    </p>    
                                </div> -->
                                
                            </div>
                        </div>
                    </div>
                
                </b-col>
            
                <b-col>
                  <div class="row h-100" v-if="loading">
                    <div class="col-sm-12 align-self-center">
                      <h3>We love our community</h3>
                    </div>
                  </div>
                    <div class="row" v-else>
                        <div v-for="s in socialData" :key="s.id">
                            <a :href="'https://www.instagram.com/p/' + s.name + '/'"> <img :src="s.pic" height="250x" ></a>
                        </div>  
                    </div>
                </b-col>
            </div>
        </b-container>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'social',
    props: {
        serviceType:  String
  },
  data () {
    return {
      socialData: {},
      loading: true,
      new: null
    }
  },
  methods: {
     async getSocial() {
            const response = await fetch('https://www.instagram.com/beauteintegrale/?__a=1', {mode: 'no-cors'});
            console.log(response.json())
            //  axios.options('https://www.instagram.com/beauteintegrale/?__a=1')
            //     .then((response) => {
            //         if(response.status === 200) {
            //             const html = response.data;
            //             // console.log(html.graphql.user.edge_owner_to_timeline_media.edges);
            //             var insta = html.graphql.user.edge_owner_to_timeline_media.edges
            //             var i = insta.length
            //             var x;
            //             // console.log(i)
            //             var dataAll = []
            //             for (x = 0; x < i; x++  ) {
            //               var data = {'name': insta[x].node.shortcode,
            //                      'pic': insta[x].node.display_url
            //               }
                        
            //             dataAll.push(data)  
            //             }
            //             this.socialData = dataAll
            //             // console.log(this.socialData) 
            //             this.loading=false   
            //         }
            //         }, (err) => console.log(err) );
        },
      async instagramPhotos () {
        // It will contain our photos' links
        const res = []
        
        try {
            const userInfoSource = await axios.get('https://www.instagram.com/beauteintegrale/')

            // userInfoSource.data contains the HTML from Axios
            const jsonObject = userInfoSource.data.match(/<script type="text\/javascript">window\._sharedData = (.*)<\/script>/)[1].slice(0, -1)

            const userInfo = JSON.parse(jsonObject)
            // Retrieve only the first 10 results
            const mediaArray = userInfo.entry_data.ProfilePage[0].graphql.user.edge_owner_to_timeline_media.edges.splice(0, 10)
            for (let media of mediaArray) {
                const node = media.node
                
                // Process only if is an image
                if ((node.__typename && node.__typename !== 'GraphImage')) {
                    continue
                }

                // Push the thumbnail src in the array
                res.push(node.thumbnail_src)
            }
        } catch (e) {
            console.error('Unable to retrieve photos. Reason: ' + e.toString())
        }
        
        this.new = res
    }     
  },
  mounted () {
    this.instagramPhotos()
  }
}

</script>

<style scoped>
.mycontainer-main {
    height:  calc(80vh);
}
  :root{
    --color: #95e9ef;
    --background: #1f1f1f;
    --spacing: 1rem;
    --speed: 1700ms;
    --fontsize: 2rem;
    }
  /* body{
    margin: 0;
    padding: var(--spacing);
    font-family: Karbon, Helvetica, sans-serif;
    color: var(--color);
    background: var(--background);
  } */
  #socialfeed{
    display: grid;
    grid-gap: var(--spacing);
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    min-height: calc(100vh - var(--spacing)*2);
  }
  /* h1{
    align-self: start;
  } */
  /* h1, button{
    margin: 0;
    padding: 0;
    grid-column: 1 / -1;
    font-size: var(--fontsize);
    line-height: 1.2;
    font-weight: 300;
    border: 4px solid var(--color);
    border-width: 4px 0;
  } */
  img{
    max-width: 100%;
    display: block;
  }
  /* button{
    border-radius: 0;
    color: var(--color);
    background: transparent;
    grid-column: 1 / -1;
    outline: none;
    cursor: pointer;
    align-self: end;
  }
  a{
    color: inherit;
    text-decoration: none;
  } */
  .error{
    grid-column: 1 / -1;
    justify-self: center;
  }
  .loading{
    width: calc(var(--spacing)*3);
    height: calc(var(--spacing)*3);
    grid-column: 1 / -1;
    justify-self: center;
    align-self: center;
    background: var(--color);
    animation: load var(--speed) infinite ease-in-out;
    transform: rotate(0);
  }
  @keyframes load{
    100%{
      transform: rotate(360deg);
    }
  }
a {
  color: black;
}
</style>


// WEBPACK FOOTER //
// src/pages/Social.vue